import React, { FC } from 'react';
import { Card, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { useIsMobileDimension } from '@beef/ui-kit/hooks';

import { ClickableLayout } from '../ClickableLayout';
import { Menu } from './components/Menu';
import { Price } from './components/Price';
import { Accumulators } from './components/Accumulators';
import { Details } from './components/Details';
import { TariffCardProps } from './types';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const TariffCard: FC<TariffCardProps> = ({
  tariffUrl,
  linkText,
  contextMenu,
  tariffMoreAvailable,
  detailsProps,
  priceProps,
  accumulatorsProps,
  onMenuClick,
  onMenuIconDotsClick,
}) => {
  const isMobile = useIsMobileDimension();

  return (
    <ClickableLayout href={tariffUrl} isClickable={!!tariffUrl} srOnlyText={linkText}>
      <Card className={cn('wrap')}>
        <Details
          {...detailsProps}
          menuSlot={
            contextMenu?.length ?
              <Menu
                menuOptions={contextMenu}
                onChange={onMenuClick}
                onClick={onMenuIconDotsClick}
              />
            : undefined
          }
          priceSlot={<Price {...priceProps} />}
        />
        {!!accumulatorsProps?.accumulators?.length && (
          <Accumulators {...accumulatorsProps} className={isMobile ? 'mar-t-m' : 'mar-t-2xl'} />
        )}
        {tariffMoreAvailable ?
          <Text color="grey60" size="size5-r-s">
            {tariffMoreAvailable}
          </Text>
        : null}
      </Card>
    </ClickableLayout>
  );
};
